export const genesisBlocks = {
    main: {
        number: 0,
        id: '0x00000000851caf3cfdb6e899cf5958bfb1ac3413d346d43539627e6be7ec1b4a',
        size: 170,
        parentID: '0xffffffff53616c757465202620526573706563742c20457468657265756d2100',
        timestamp: 1530316800,
        gasLimit: 10000000,
        beneficiary: '0x0000000000000000000000000000000000000000',
        gasUsed: 0,
        totalScore: 0,
        txsRoot: '0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0',
        txsFeatures: 0,
        stateRoot: '0x09bfdf9e24dd5cd5b63f3c1b5d58b97ff02ca0490214a021ed7d99b93867839c',
        receiptsRoot: '0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0',
        signer: '0x0000000000000000000000000000000000000000',
        isTrunk: true,
        transactions: []
    },
    test: {
        number: 0,
        id: '0x000000000b2bce3c70bc649a02749e8687721b09ed2e15997f466536b20bb127',
        size: 170,
        parentID: '0xffffffff00000000000000000000000000000000000000000000000000000000',
        timestamp: 1530014400,
        gasLimit: 10000000,
        beneficiary: '0x0000000000000000000000000000000000000000',
        gasUsed: 0,
        totalScore: 0,
        txsRoot: '0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0',
        txsFeatures: 0,
        stateRoot: '0x4ec3af0acbad1ae467ad569337d2fe8576fe303928d35b8cdd91de47e9ac84bb',
        receiptsRoot: '0x45b0cfc220ceec5b7c1c62c4d4193d38e4eba48e8815729ce75f9c0ab0e4c1c0',
        signer: '0x0000000000000000000000000000000000000000',
        isTrunk: true,
        transactions: []
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NvbmZpZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUc7SUFDekIsSUFBSSxFQUFFO1FBQ0YsTUFBTSxFQUFFLENBQUM7UUFDVCxFQUFFLEVBQUUsb0VBQW9FO1FBQ3hFLElBQUksRUFBRSxHQUFHO1FBQ1QsUUFBUSxFQUFFLG9FQUFvRTtRQUM5RSxTQUFTLEVBQUUsVUFBVTtRQUNyQixRQUFRLEVBQUUsUUFBUTtRQUNsQixXQUFXLEVBQUUsNENBQTRDO1FBQ3pELE9BQU8sRUFBRSxDQUFDO1FBQ1YsVUFBVSxFQUFFLENBQUM7UUFDYixPQUFPLEVBQUUsb0VBQW9FO1FBQzdFLFdBQVcsRUFBRSxDQUFDO1FBQ2QsU0FBUyxFQUFFLG9FQUFvRTtRQUMvRSxZQUFZLEVBQUUsb0VBQW9FO1FBQ2xGLE1BQU0sRUFBRSw0Q0FBNEM7UUFDcEQsT0FBTyxFQUFFLElBQUk7UUFDYixZQUFZLEVBQUUsRUFBRTtLQUNuQjtJQUNELElBQUksRUFBRTtRQUNGLE1BQU0sRUFBRSxDQUFDO1FBQ1QsRUFBRSxFQUFFLG9FQUFvRTtRQUN4RSxJQUFJLEVBQUUsR0FBRztRQUNULFFBQVEsRUFBRSxvRUFBb0U7UUFDOUUsU0FBUyxFQUFFLFVBQVU7UUFDckIsUUFBUSxFQUFFLFFBQVE7UUFDbEIsV0FBVyxFQUFFLDRDQUE0QztRQUN6RCxPQUFPLEVBQUUsQ0FBQztRQUNWLFVBQVUsRUFBRSxDQUFDO1FBQ2IsT0FBTyxFQUFFLG9FQUFvRTtRQUM3RSxXQUFXLEVBQUUsQ0FBQztRQUNkLFNBQVMsRUFBRSxvRUFBb0U7UUFDL0UsWUFBWSxFQUFFLG9FQUFvRTtRQUNsRixNQUFNLEVBQUUsNENBQTRDO1FBQ3BELE9BQU8sRUFBRSxJQUFJO1FBQ2IsWUFBWSxFQUFFLEVBQUU7S0FDbkI7Q0FDSixDQUFBIn0=